import React, { useState, useEffect } from 'react';

const ProjectTracker = ({ user }) => {
  const [trackerUrl, setTrackerUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Get the tracker URL with auth token
    const setupTracker = async () => {
      try {
        const token = user.signInUserSession.idToken.jwtToken;
        
        // Your tracker CloudFront URL
        const baseTrackerUrl = 'https://d392zzgg6lxugw.cloudfront.net';
        
        // For now, we'll load it directly. Later we can add token validation
        setTrackerUrl(baseTrackerUrl);
        setLoading(false);
      } catch (err) {
        console.error('Failed to setup tracker:', err);
        setError('Failed to load project tracker');
        setLoading(false);
      }
    };

    setupTracker();
  }, [user]);

  if (loading) {
    return <div className="text-center mt-5">Loading project tracker...</div>;
  }

  if (error) {
    return <div className="alert alert-danger">{error}</div>;
  }

  return (
    <div style={{ height: 'calc(100vh - 100px)' }}>
      <h3 className="mb-3">📊 Project Tracker</h3>
      <div className="alert alert-info mb-3">
        <small>Project completion: 52% tracked, ~75% actual. Critical tasks remaining: ~40-50 hours</small>
      </div>
      <iframe
        src={trackerUrl}
        style={{ 
          width: '100%', 
          height: '100%', 
          border: '1px solid #ddd',
          borderRadius: '8px'
        }}
        title="Project Tracker"
      />
    </div>
  );
};

export default ProjectTracker;
